export enum StorageKey {
  Role = 'role',
  User = 'user',
  Intermediary = 'intermediary',
  SessionId = '_session_id',
  ProgramId = '_program_id',
  SiteId = '_site_id',
  ProgramIdUrl = 'program_id_url',
  PortfolioId = 'portfolioId',
  AdminSession = '_admin_session',
  AccessInviteReportViewer = '_accessInviteReportViewer',
  LastEventTime = '_last_event_time',
  PreviousUrl = '_previousUrl',
  NextUrl = '_nextUrl',
  Token = 'token',
  Stage = 'stage',
  Organization = 'organization',
  ToolName = 'tool_name',
  CurrentToolName = 'currentToolName',
  CurrentNav = 'currentNav',
  ReportType = 'reportType',
  ReportData = 'reportData',
  Subscriptions = 'subscriptions',
  CheckinAllowed = 'checkin_allowed',
  PrepostAllowed = 'prepost_allowed',
  ManageProgramStep = 'manageProgramStep',
  ManageProgramGroupEditSite = 'manageProgramGroupEditSite',
  ManageProgramGroupEdit = 'manageProgramGroupEdit',
  ProgramData = 'programData',
  TrackingStep = 'tracking_step',
  FrontendVersion = 'frontend_version',
  InitiativeSelected = 'initiative_selected_getting_ready',
  PortfolioFilters = 'portfolio_filters_selection',
  LocalInitiative = 'localInitiative',
  PortfolioName = 'portfolio_name',
  ShowSelection = 'show_selection',
  OldPortfolioName = 'old_portfolio_name',
  OldPortfolioFilters = 'old_portfolio_filters_selection',
  PortfolioState = 'portfolio_state',
  PortfolioFilterSelection = 'portfolio_filter_selections',
  OldPortfolioFilterSelection = 'old_portfolio_filter_selections',
  OldPortfolioState = 'old_portfolio_state',
  OriginalReportName = 'original_report_name',
  ImpactSummariesAccessPoint = 'impact_summaries_access_point',
  Filters = 'filters',
  StepResult = 'step_result',
}
